<template>
  <div>
    <el-carousel class="my-el-carousel" :interval="5000" arrow="always" style="margin: 20px auto 35px;">
      <el-carousel-item v-for="(ad, i) in adList" :key="i">
        <div @click="goListByAD(ad)" :style="`background-image: url(${ad.image})`" class="ad-img"></div>
        <!-- <img @click="goListByAD(ad)" :src="ad.image" /> -->
      </el-carousel-item>
      <!-- <el-carousel-item>
        <img src="../assets/ad.png" />
      </el-carousel-item>
      <el-carousel-item v-for="(item, i) in imgList" :key="i">
        <img :src="item" />
      </el-carousel-item>-->
    </el-carousel>

    <!-- <el-divider></el-divider> -->
    <!-- 特色专区 -->
    <!-- <div style="text-align: center">
      <img src="../assets/icon/tszq.jpg" />
    </div> -->
     <div class="commonTitle tszq" >
      <el-divider></el-divider>
      <span class="title">
        <img src="@/assets/index-4.png" alt="">
      </span>
    </div>
    <div class="tuijian" style="margin-top: 35px;" v-if="top3List.length>0">
      <div class="topList">
        <div class="topList_left">
           <div class="img1 topsImgBox" style="width: 100%;" v-for="(item,i) in top3List" @click="goListSpecial(item)" :key="i" v-if="i<1">
              <div v-if="item.image" :style="{'background-image': `url(${item.image})`}" style="background-size: cover;"></div>
              <div v-else :style="{'background-image': `url(${noImg})`}"></div>
              <!-- <p  class="name">{{item.name}}</p> -->
               <!-- <img src="../assets/more.png" class="learnMore topLearn" alt=""> -->
              <!-- <span class="learnMore topLearn">
                了解更多 》
              </span> -->
            </div>
            <!-- <img :src="top3List[0].image" alt=""> -->
            <!-- <div v-if=" top3List.length>0&&top3List[0].image"  :style="{'background-image': `url(${top3List[0].image})`}"></div> -->
            <!-- <div :style="{'background-image': `url(${noImg})`}"></div>
            <p v-if="top3List[0].isShow == 1" class="name">{{top3List[0].name}}</p> -->
        </div>
        <div class="topList_right">
           <div class="one">
             <div class="NameBox">
               <div>
                 <!-- <p>{{top3List[2].name}}</p> -->
                  <!-- <img src="../assets/more.png" class="learnMore topLearn" @click="goListSpecial(top3List[2])" alt=""> -->
                  <!-- <span class="learnMore topLearn">
                    了解更多 》
                  </span> -->
               </div>

             </div>
             <div class="imgBox">
               <div class="img1 topsImgBox" style="width: 100%;"  @click="goListSpecial(top3List[2])" >
                  <div v-if="top3List[2].image" :style="{'background-image': `url(${top3List[2].image})`}" style="background-size: cover;"></div>
                  <div v-else :style="{'background-image': `url(${noImg})`}"></div>
                </div>
             </div>
           </div>
           <div class="one two">
             <div class="NameBox">
               <div>
                 <!-- <p>{{top3List[1].name}}</p> -->
                  <!-- <img src="../assets/more.png" class="learnMore topLearn" @click="goListSpecial(top3List[1])" alt=""> -->
                  <!-- <span class="learnMore topLearn">
                    了解更多 》
                  </span> -->
               </div>

             </div>
             <div class="imgBox">
               <div class="img1 topsImgBox" style="width: 100%;"  @click="goListSpecial(top3List[1])" >
                  <div v-if="top3List[1].image" :style="{'background-image': `url(${top3List[1].image})`}" style="background-size: cover;"></div>
                  <div v-else :style="{'background-image': `url(${noImg})`}"></div>
                </div>
             </div>
           </div>
        </div>
      </div>
      <div class="img" v-for="(item,i) in newrecomGoods" @click="goListSpecial(item)" :key="i">
        <img :src="item.image || noImg" alt="">
      </div>
    </div>
    <!-- 推荐 -->
    <div v-if="recomendsList.length>0||recomendAd.length>0">
      <div class="commonTitle tszq" >
        <el-divider></el-divider>
        <span class="title">
          <img src="@/assets/index-1.png" alt="">
        </span>
      </div>

      <el-carousel class="my-el-carousel" :interval="5000" arrow="always" v-if="recomendAd.length>0" style="margin-top: 35px;">
        <el-carousel-item v-for="(ad, i) in recomendAd" :key="i">
          <div @click="goRecomend(ad)" :style="`background-image: url(${ad.logo})`" class="ad-img"></div>
          <!-- <img @click="goListByAD(ad)" :src="ad.image" /> -->
        </el-carousel-item>
        <!-- <el-carousel-item>
          <img src="../assets/ad.png" />
        </el-carousel-item>
        <el-carousel-item v-for="(item, i) in imgList" :key="i">
          <img :src="item" />
        </el-carousel-item>-->
      </el-carousel>

       <div class="tuijian" style="margin-top: 35px;" v-if="recomendsList.length > 0">
          <div class="img recomendImg"  v-for="(item,i) in recomendsList" @click="goRecomend(item)" :key="i">
            <div class="titleName tuijianNameBox">
              <h3>{{item.name}}</h3>
              <p v-html="item.intro"></p>

            </div>
            <div class="backImg">
              <img :src="item.logo || noImg" alt="">
            </div>
            <p v-if="item.isShow == 1" class="name">{{item.name}}</p>
          </div>
        </div>

    </div>
    <div class="buy-way">
      <img style="width: 33%;cursor: pointer;" src="../assets/howbuy.png" @click="howBuy('/help?id=13')" usemap="#mymap" />
      <!-- <img style="width: 1120px; margin-left: 25px;" src="../assets/how-to-buy.png" usemap="#mymap" />
      <map name="mymap">


        <area shape="rect" coords="13, 0, 1080, 112" href="/#/help?id=13" />
        <area shape="rect" coords="13, 412, 340, 575" href="/#/help?id=6" />
        <area shape="rect" coords="384, 412, 711, 575" href="/#/help?id=10" />
        <area shape="rect" coords="755, 412, 1082, 575" href="/#/help?id=7" />
      </map> -->
    </div>
    <!-- 关于我们 -->
    <div class="aboutUs">
      <div class="commonTitle" style="margin-top:70px;">
        <el-divider></el-divider>
        <span class="title">
          <img src="@/assets/index-2.png" alt="">
        </span>
      </div>
      <div class="usLiset">
        <div v-for="(v, index) in introAll" :key="index">
          <a :href="v.url">
            <img :src="v.cover" :alt="v.name">
          </a>
        </div>
<!--        <div @click="howBuy('/help?id=6')">
          <img src="../assets/shouhou.jpg" alt="">
        </div>
        <div  @click="howBuy('/help?id=10')">
          <img src="../assets/gonghuo.jpg" alt="">
        </div>
        <div  @click="howBuy('/help?id=7')">
          <img src="../assets/pay.jpg" alt="">
        </div>-->
      </div>
    </div>


     <!-- 合作伙伴 -->
    <template v-if="$store.state.user.username">
      <!-- <el-divider>
        <img src="../assets/icon/hzhb.jpg" />
      </el-divider> -->
      <div class="commonTitle">
        <el-divider></el-divider>
        <span class="title">
          <img src="@/assets/index-3.png" alt="">
        </span>
      </div>
      <div class="brand-area" @mouseenter="stoploop" @mouseleave="startloop">
        <div class="brand-list">
          <i class="el-icon-arrow-left" @click="goBrandPage(scrollLeft-1)"></i>
          <div class="img-box">
            <div
              class="img-list"
              :style="`margin-left: ${-100*scrollLeft}%; width: ${brandList.length * 200}px;`"
            >
              <template v-for="(item, i) in brandList">
                <div class="img">
                  <img
                    @contextmenu.prevent
                    @click="goListBrand(item)"
                    v-if="item.logPath"
                    :src="item.logPath"
                  />
                  <img
                    @contextmenu.prevent
                    @click="goListBrand(item)"
                    v-else
                    src="../assets/no-picture.png"
                  />
                </div>
              </template>
            </div>
          </div>
          <i class="el-icon-arrow-right" @click="goBrandPage(scrollLeft+1)"></i>
        </div>
      </div>
    </template>
    <!-- <p class="able" @click="$router.push('/help?active=1')">如何购买</p> -->
  </div>
</template>

<script>
import noImg from "../assets/no-picture.png";
import HeaderNav from "./header-nav";
import FooterNav from "./footer-nav";
import { brand, special, advertising ,recomends,introAll} from "../js/api";

export default {
  components: { HeaderNav, FooterNav },
  name: "Home",
  data() {
    return {
      timer: 0,
      noImg,
      brandList: [],
      scrollLeft: 0,
      recomGoods: [],
      newrecomGoods:[],
      top3List:[],
      adList: [],
      imgList: [
        // "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1578224667050&di=8ee46e861cf0c17e235bc8d774b69dbc&imgtype=0&src=http%3A%2F%2Ffile02.16sucai.com%2Fd%2Ffile%2F2015%2F0128%2F8b0f093a8edea9f7e7458406f19098af.jpg",
      ],
      recomendsList:[],
      recomendAd:[],
      introAll: []
    };
  },
  mounted() {
    special({}).then(res => {
      if (res.code == 0) {
        this.recomGoods = res.result.records || [];
        console.log(this.recomGoods)
        if(this.recomGoods.length>=3){
          // this.top3List =this.recomGoods.slice(0,3)

          for(var i=0;i<this.recomGoods.length;i++){
            if(i<3){
               this.top3List.push(this.recomGoods[i])
            }else{
              this.newrecomGoods.push(this.recomGoods[i])
            }

          }
          // this.newrecomGoods = this.recomGoods.splice(-3)
        }else{
          this.newrecomGoods = this.recomGoods
        }
         console.log(this.top3List)
      }
    });
    advertising({}).then(res => {
      if (res.code == 0) {
        this.adList = res.result.records || [];
      }
    });
    // roleList({}).then(res => {
    //   if (res) {
    //     console.log(res);
    //   }
    // });
    brand({}).then(res => {
      if (res.code == 0) {
        this.brandList = res.result.records || [];
      }
    });
    recomends({}).then(res=>{
      console.log('recomends',res)
      if(res.success){
        let list = res.result.records||[]
        if(list.length>0){
          this.recomendsList = list.filter(function(item){
            return item.level!=1
          })
          this.recomendAd = list.filter(function(item){
            return item.level==1
          })
        }
        // this.recomendsList=[{
        //   logo:'http://39.99.175.196:80/kufeng-admin/0aa6267cd12c45dfa530174d07b153bf.png',
        //   name:'测试',
        //   intro:'outDoor Plan'
        // }]

      }

    })

    introAll('icon').then(res => {
      if (res.success) {
        this.introAll = res.result[0]['children']
      }
    })

    this.startloop();
  },
  methods: {
    howBuy(href){
      this.$router.push(href)

    },
    goListByAD(ad) {
      this.$router.push(
        `goodsList?advertiseId=${ad.id}&label=${ad.name}&image=${ad.image}`
      );
    },
    goBrandPage(n) {
      if (n >= 0 && n < this.brandList.length / 5) this.scrollLeft = n;
    },
    autoGoNext() {
      const n = this.scrollLeft + 1;
      if (n >= 0 && n < this.brandList.length / 5) this.goBrandPage(n);
      else this.goBrandPage(0);
    },
    startloop() {
      this.timer = setInterval(this.autoGoNext, 5000);
    },
    stoploop() {
      clearInterval(this.timer);
    },
    goListBrand(item) {
      this.$router.push(`goodsList?brandId=${item.id}&label=${item.name}`);
    },
    goListSpecial(item) {
      this.$router.push(`goodsList?specialId=${item.id}&label=${item.name}`);
    },
    goRecomend(item) {
      this.$router.push(`recomendlist?specialId=${item.id}&label=${item.name}&image=${item.logo}`);
    },
    goDetail: function(item) {
      if (item && item.id) {
        this.$router.push(`goodsdetail?id=${item.id}&groupNo=${item.groupNo}`);
        location.reload();
      }
    }
  }
};
</script>

<style scoped>
.my-el-carousel >>> .el-carousel__container {
  height: 420px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.tszq{
  .el-divider--horizontal{

  }
}
.el-divider--horizontal{
   width: 88%;
    margin: 10px auto;
  background: none;
   border-bottom: dashed 1px #DCDFE6;
}
// 关于我们
.commonTitle{
  position: relative;
  width:100%;
  .title{
    display: flex;
    align-items: center;
    justify-content: center;
    //color: #fff;
    padding: 3px 16px;
    //background-color: #666;
    // width: 100px;
    position: absolute;
    font-size: 20px;
    left: 50%;
    top: -15px;
    transform: translateX(-50%);
    background-color: #fff;
    img{height: 24px;}
  }
}
.aboutUs{
  width: 100%;
  margin: 0 auto;
  .el-divider--horizontal{
    width: 93%;
  }
}
.usLiset{
  display: flex;
  // width: 95%;
  margin: 40px auto;
  div{
    flex: 1;
    margin-left: 10px;
    text-align: center;
    img{
      width: 80%;
      // max-height: 160px;
      cursor: pointer;
    }
  }
}
.my-el-carousel,
.brand-area {
  width: 1060px;
  margin: auto;
}
.ad-img {
  width: 100%;
  height: 100%;
  background-size: cover;
  cursor: pointer;
}
.learnMore{
  color: #fff;
  cursor: pointer;
  // border: 2px solid #fff;
  // padding: 6px 10px;
  // border-radius: 10px;
  // background-color: rgb(111,186,42);
      width: 90px;
    text-align: center;
    box-sizing: border-box;
}
.tuijian {
  width: 1060px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  .topList{
    width: 100%;
    display: flex;
    margin: 10px 0 35px;
    .topList_left,.topList_right{
      flex: 1;
    }

    .topList_left{
      // height: 400px;
      .topsImgBox{
        position: relative;
        width: 100%;
        height: 580px;
        .name{
          background: none;
          position: absolute;
          right: 5px;
          top: 10px;
          color: #fff;
          width: auto;
          height: auto;
          font-size: 44px;
          font-weight: bolder;
        }
        .topLearn{
          position: absolute;
          right: 5px;
          bottom: 5px;
        }
      }
    }
    .topList_right{
      width: 50%;
      margin-left: 15px;
      .two{
        margin-top: 20px;
      }
     .one{
        display: flex;
        // align-items: center;
        //  justify-content: center;
        .NameBox{
          background-color: transparent;
          width: 0;
          height: 280px;
          margin-top: 0px;
          div{
            width: 90%;
            margin: 0 auto;
            position: relative;
            height: 100%;
            padding: 5px;
            p{
              font-size: 38px;
              color: #fff;
              font-weight: bolder;
            }
            .topLearn{
              position: absolute;
              bottom: 15px;
              left: 50%;
              // width: 100%;
              transform: translateX(-50%);
            }
          }
        }
      }
      .imgBox{
        .topsImgBox{
          height: 280px;
        }
        width: 100%;
        height: 280px;
        img{
          width: 100%;
          height: 100%;
        }
      }

    }
  }
  .topList:nth-child(-n + 2){margin-top: 0;}
  .img {
    margin: 0px 0 35px 0;
     &.recomendImg{
      margin: 0px 0 35px 0;
    }
    width: 330px;
    height: 430px;overflow: hidden;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    .titleName{
      background-color:rgb(208,204,79);
      box-sizing: border-box;
      text-align: center;
      &.tuijianNameBox{
        background-color: rgba(0, 0, 0, .6) !important;
        position: absolute;
        width: 100%;
        bottom: 15px;
        left: 0;
        p{
          color: #fff;
          font-size: 26px;
          font-weight: bolder;
          max-height:100px ;
          overflow: auto;
        }
        h3{
          margin-bottom: 5px;
        }
      }
      h3{
        font-size: 30px;
        font-weight: bolder;
        color: #fff;
        margin-bottom: 10px;
      }
      // .topLearn{
      //   margin-top: 30px;
      // }
    }
    .backImg {
      width: 100%;
      height: 100%;
      // background-size: contain;
      background-size: auto 100%;
      background-position: center;
      background-repeat: no-repeat;
      // border: solid 1px #ccc;
    }
    p.name {
      position: absolute;
      bottom: 0;
      width: 260px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 20px 20px 0 0;
      background: #fdd000;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      font-size: 18px;
      color: #428a7b;
      font-weight: bold;
    }
  }

   .img1 {
    margin: 0px 0;
    width: 300px;
    height: 300px;
    // display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    .titleName{
      background-color:rgb(208,204,79) ;
      padding: 10px;
      box-sizing: border-box;
      margin-top: 10px;
    }
    div {
      width: 100%;
      height: 100%;
      // background-size: contain;
      background-size: auto 100%;
      background-position: center;
      background-repeat: no-repeat;
      // border: solid 1px #ccc;
    }
    p.name {
      // position: absolute;
      // bottom: 0;
      // width: 260px;
      // height: 40px;
      // text-align: center;
      // line-height: 40px;
      // border-radius: 20px 20px 0 0;
      // background: #fdd000;

      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;

      // font-size: 18px;
      // color: #428a7b;
      // font-weight: bold;
    }
  }
}
.brand-list {
  display: flex;
  align-items: center;
  i {
    font-size: 40px;
    color: #ccc;
    cursor: pointer;
  }
  .img-box {
    display: block;
    align-items: center;
    overflow: hidden;
    width: 980px;
    height: 175px;
    .img-list {
      transition: all linear 0.5s;
      height: 175px;
    }
    .img {
      margin: 0 10px;
      width: 175px;
      height: 175px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
    }
    img {
      max-width: 100%;
      max-height: 200px;
      cursor: pointer;
    }
  }
}
.buy-way {
  margin-top: 70px;
  text-align: center;
}
</style>
